
import { useStore } from '@/store'
import { defineComponent, ref, onMounted } from 'vue'
import { computed } from 'vue'
import tackSettings from '@/settings/tack-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'
import StageDeterminerService from '@/services/page/stage-determiner.service'
import FormColorPicker from '@/components/Form/FormColorPicker.vue'
import { ColorpickerActionTypes } from '@/store/modules/colorpicker/action-types'

export default defineComponent({
  name: 'FormTack',
  components: {
    FormScrollableTab,
    FormOption,
    FormColorPicker
  },
  props: {
    index: Number
  },
  setup() {
    let stageDeterminer = new StageDeterminerService()
    const store = useStore()
    const configName = ref('configTackId')
    const colorpicker = ref("#2e2e2e")
    const showColorPicker = ref(false)
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => tackSettings.options)

    onMounted(() => {
      if (stageDeterminer.isColorpickerVisible()) {
        showColorPicker.value = true
      }
    })

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_TACK, option.id)
      Analytics.instance.sendTackEvent(option.id)

      colorpicker.value = option.value || "#2e2e2e";
    }
    
    const onColorPickerUpdate = (val) => {
      store.dispatch(ColorpickerActionTypes.SET_COLORPICKER_TACK, val)
    }

    return {
      config,
      configName,
      tackSettings,
      colorpicker,
      onClick,
      onColorPickerUpdate,
      options,
      showColorPicker
    }
  }
})
